const jsSkills = [{
        skillName: "JavaScript",
        level: "92",
        colour: "info"
    },
    {
        skillName: "React.js",
        level: "85",
        colour: "success"
    },
    {
        skillName: "jQuery",
        level: "70",
        colour: "success"
    },
    {
        skillName: "DC.js & D3.js",
        level: "40",
        colour: "success"
    }
]

const pySkills = [{
        skillName: "Python",
        level: "80",
        colour: "info"
    },
    {
        skillName: "Django",
        level: "90",
        colour: "success"
    },
    // {
    //     skillName: "Django REST Framework",
    //     level: "60",
    //     colour: "success"
    // },
    {
        skillName: "Flask",
        level: "60",
        colour: "success"
    }
]

const mobileDevSkills = [{
        skillName: "Flutter",
        level: "50",
        colour: "info",
    },
    {
        skillName: "Bloc",
        level: "40",
        colour: "success"
    }
]

const dbSkills = [{
        skillName: "MongoDB",
        level: "90",
        colour: "info"
    },
    {
        skillName: "MySQL",
        level: "75",
        colour: "info"
    },
    {
        skillName: "PostgresSQL",
        level: "75",
        colour: "info"
    }
]

const ucdSkills = [{
        skillName: "HTML",
        level: "95",
        colour: "info"
    },
    {
        skillName: "CSS",
        level: "92",
        colour: "info"
    },
    {
        skillName: "SCSS",
        level: "92",
        colour: "success"
    },
    {
        skillName: "Bootstrap",
        level: "95",
        colour: "success"
    }
]

const versionControl = [{
        skillName: "Github",
        level: "90",
        colour: "info"
    },
    {
        skillName: "Heroku",
        level: "90",
        colour: "info"
    },
    {
        skillName: "Amazon Web Service S3",
        level: "90",
        colour: "info"
    },
    {
        skillName: "Git",
        level: "90",
        colour: "info"
    }
]

const otherTools = [{
        skillName: "Webflow",
        level: "95",
        colour: "info"
    },
    {
        skillName: "Adobe XD",
        level: "95",
        colour: "info"
    }
]

export {
    jsSkills,
    pySkills,
    mobileDevSkills,
    dbSkills,
    ucdSkills,
    versionControl,
    otherTools
}